import { campaignCouponService } from "@/api/campaignCouponService";
import { packageCouponService } from "@/api/packageCouponService";

async function executeCouponDelete(
  operation: () => Promise<boolean>,
  entityType: string,
  id: string,
  couponCode: string,
): Promise<void> {
  try {
    const result = await operation();
    if (!result) {
      throw new Error(
        `Failed to delete coupon ${couponCode} from ${entityType} ${id}`,
      );
    }
  } catch (error) {
    console.error(
      `Failed to delete coupon ${couponCode} from ${entityType} ${id}:`,
      error,
    );
    throw error;
  }
}

export async function deleteCoupon(
  collectionName: "packages" | "campaigns",
  id: string,
  couponCode: string,
): Promise<void> {
  if (!collectionName || !id || !couponCode) {
    throw new Error(
      "Invalid parameters: collection, id and couponCode are required",
    );
  }

  if (collectionName !== "packages" && collectionName !== "campaigns") {
    throw new Error(
      'Invalid collection name. Must be "packages" or "campaigns".',
    );
  }

  if (collectionName === "campaigns") {
    await executeCouponDelete(
      () =>
        campaignCouponService.deleteByCampaignIdAndCouponCode(id, couponCode),
      "campaign",
      id,
      couponCode,
    );
  } else if (collectionName === "packages") {
    await executeCouponDelete(
      () => packageCouponService.deleteByPackageIdAndCouponCode(id, couponCode),
      "package",
      id,
      couponCode,
    );
  }
}
